interface formateTimeParams {
  hours: number;
  minutes: number;
  seconds: number;
};

export const defaultFormattedValue = '00:00:00';

export const dateFormatter = (dateToFormat: Date): string => {
  if (!(dateToFormat instanceof Date)) {
    return defaultFormattedValue;
  }

  if (dateToFormat < new Date(0)) {
    return defaultFormattedValue;
  }

  const timeStamp = dateToFormat.getTime();
  const totalSeconds = Math.floor(timeStamp / 1000);
  const seconds = totalSeconds % 60;
  const totalMinutes = Math.floor(totalSeconds / 60);
  const minutes = totalMinutes % 60;
  const totalHours = Math.floor(totalMinutes / 60);
  const hours = totalHours % 24;
  const totalDays = Math.floor(totalHours / 24);
  const years = Math.floor(totalDays / 365);
  const remainingDaysAfterYears = totalDays % 365;
  const months = Math.floor(remainingDaysAfterYears / 30);
  const days = remainingDaysAfterYears % 30;

  const formatPartDate = (part: number, textFormats: string[]) => {
    if (part === 0) return '';

    const lastDigit = part % 10;
    const lastTwoDigits = part % 100;

    if (lastDigit === 1 && lastTwoDigits !== 11) {
      return `${ part } ${ textFormats[0] }`;
    } else if ([2, 3, 4].includes(lastDigit) && ![12, 13, 14].includes(lastTwoDigits)) {
      return `${ part } ${ textFormats[1] }`;
    } else {
      return `${ part } ${ textFormats[2] }`;
    }
  };

  const formatTime = ({ hours, minutes, seconds }: formateTimeParams) => {
    const formatNumber = (num: number) => num.toString().padStart(2, '0');
    return `${ formatNumber(hours) }:${ formatNumber(minutes) }:${ formatNumber(seconds) }`;
  };

  const yearsPart = formatPartDate(years, ["год", "года", "лет"]);
  const monthsPart = formatPartDate(months, ["месяц", "месяца", "месяцев"]);
  const daysPart = formatPartDate(days, ["день", "дня", "дней"]);
  const timePart = formatTime({ hours, minutes, seconds });

  const parts = [yearsPart, monthsPart, daysPart].filter(part => part !== '');

  if (parts.length > 0) {
    return `${ parts.join(' ') } \n ${ timePart }`;
  } else {
    return timePart;
  }
};
